import { useState } from "react";
import { Mail, Check, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterSignup({ source = "blog" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [consent, setConsent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email)) return toast.error("Zadajte platný e-mail.");
    if (!consent) return toast.error("Potvrďte súhlas so zasielaním noviniek.");
    setBusy(true);
    try {
      await api.post("/newsletter", { email, source });
      setDone(true);
      toast.success("Ďakujeme! Budeme vás informovať o novinkách.");
    } catch {
      toast.error("Prihlásenie zlyhalo, skúste to znova.");
    } finally { setBusy(false); }
  };

  return (
    <div className="border border-gold/40 bg-gold/5 p-6 md:p-8" data-testid="newsletter-signup">
      <div className="flex items-center gap-2 text-gold mb-3">
        <Mail className="w-5 h-5" />
        <p className="font-mono2 uppercase tracking-[0.3em] text-xs">Odber noviniek</p>
      </div>
      <h3 className="font-display text-2xl md:text-3xl text-white mb-2">Nové rady o zatepľovaní priamo do e-mailu</h3>
      <p className="text-white/60 text-sm mb-5 max-w-lg">Postupy, dotácie, ceny a tipy pri výbere materiálu. Žiadny spam — len užitočné články a akcie.</p>
      {done ? (
        <div className="flex items-center gap-2 text-gold font-semibold" data-testid="newsletter-done">
          <Check className="w-5 h-5" /> Ste prihlásený na odber noviniek.
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-3 max-w-lg">
          <div className="flex flex-col sm:flex-row gap-3">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="newsletter-email"
              placeholder="Váš e-mail" className="flex-1 bg-transparent border border-white/20 focus:border-gold outline-none text-white px-4 py-3 text-sm" />
            <button type="submit" disabled={busy} data-testid="newsletter-submit"
              className="bg-gold text-ink px-6 py-3 font-bold uppercase tracking-wider hover:bg-gold-light flex items-center justify-center gap-2 disabled:opacity-60">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Odoberať"}
            </button>
          </div>
          <label className="flex items-start gap-3 cursor-pointer select-none" data-testid="newsletter-consent-label">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="newsletter-consent"
              className="mt-0.5 w-4 h-4 shrink-0 cursor-pointer" />
            <span className="text-white/70 text-xs leading-relaxed">
              Súhlasím so zasielaním noviniek e-mailom a so spracovaním e-mailu v zmysle{" "}
              <Link to="/ochrana-osobnych-udajov" target="_blank" className="text-gold hover:text-gold-light underline">zásad ochrany osobných údajov</Link>.
              Odber môžem kedykoľvek zrušiť.
            </span>
          </label>
        </form>
      )}
    </div>
  );
}
